import React from 'react'

function KskBoxFooter({children, className = ''}) {
  return (<footer className={`ksk-box__footer ${className}`} >{ children }</footer>);
}

export default KskBoxFooter
